import {ActivatedRouteSnapshot} from '@angular/router';
import {inject} from '@angular/core';
import {combineLatest, switchMap} from 'rxjs';
import {resolveGarfieldLocalGovernments} from './garfield-local-governments.resolver';
import {resolveDatasetsDetailFromRoute} from './garfield-datasets-detail.resolver';
import {FundsService} from '../funds.service';
import {LocalGovernment} from '../api/fit-api/models/local-government';

/**
 * Resolve and return an array of Filed Fund Nodes based on a list of governments and their datasets
 * Note: used for funds selector values
 *
 * @param route
 * @param state
 */
export const garfieldFiledFundNodesResolver= (route: ActivatedRouteSnapshot, state: any) => {
	return resolveGarfieldFiledFundNodes(route);
};

export const resolveGarfieldFiledFundNodes = (route: ActivatedRouteSnapshot) => {
	const fundsService = inject(FundsService);
	const filedFundNodes = combineLatest([resolveDatasetsDetailFromRoute(route), resolveGarfieldLocalGovernments(route)])
		.pipe(switchMap(([datasets, localGovernments]) => {
			// get just local governments
			const localGovs = localGovernments.filter(g => g instanceof LocalGovernment);

			return fundsService.getFiledFundNodes(localGovs, datasets);
	}));

	return filedFundNodes;
}
